import { render, staticRenderFns } from "./DocumentsSlotRow.vue?vue&type=template&id=2f51752a&scoped=true"
import script from "./DocumentsSlotRow.vue?vue&type=script&lang=js"
export * from "./DocumentsSlotRow.vue?vue&type=script&lang=js"
import style0 from "./DocumentsSlotRow.vue?vue&type=style&index=0&id=2f51752a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51752a",
  null
  
)

export default component.exports